var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 19.514v-8.96a.625.625 0 0 1 .963-.525l6.97 4.478a.625.625 0 0 1 0 1.053l-6.97 4.48a.626.626 0 0 1-.963-.525v-.001Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 15.033C1.25 7.44 7.406 1.283 15 1.283s13.75 6.156 13.75 13.75-6.156 13.75-13.75 13.75-13.75-6.156-13.75-13.75ZM15 3.158a11.875 11.875 0 1 0 0 23.75 11.875 11.875 0 0 0 0-23.75Z"
  })));
};
export default SvgPlay;